// index.js
import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App'
import Register from './components/Register'

import ReactDOM from 'react-dom/client'
import { AppProvider } from './context/AppContext'
// Import language context
import { LanguageProvider } from './context/LanguageContext'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <AppProvider>
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/register" element={<Register />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </AppProvider>
  </React.StrictMode>
)
